var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFolderOpenSolid = function SvgFolderOpenSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 3v24.813l.781.156 12 2.5 1.219.25V28h6V15.438l1.719-1.72.281-.312V3Zm9.125 2H25v7.563l-1.719 1.718-.281.313V26h-4v-8.906l-.281-.313L17 15.063V5.719ZM7 5.281l8 2v8.625l.281.313L17 17.937v10.344L7 26.188Z"
  })));
};
export default SvgFolderOpenSolid;